import React, {Component} from 'react';
import Rules from '../../utils/validation_rules';
import classnames from 'classnames';

export default class Checkbox extends Component {
    static defaultProps = {
        label: '',
        placeholder: null,
        id: 'input',
        validators: [],
        errorMessage: '',
        value: '',
        required: false,
        className: '',
        inline: false,
        onChange: () => {}
    }

    state = {
        isValid: true,
        error_message: null,
        show_errors: false,
        forced_error: false,
        checked: false
    }

    componentDidMount = () => {
        this.setState({
            checked: this.props.checked
        });
    }

    componentWillReceiveProps = (newProps) => {
        this.setState({
            checked: newProps.checked
        });
    }

    focus = () => {
        this._input.focus();
    }

    isChecked = () => {
        return this.state.checked;
    }

    getValue = () => {
        return this.state.checked;
    }

    validate = () => {
        let isValid = true;
        let message = this.props.errorMessage || '';
        let rules = this.props.validators;
        if (this.props.required) {
            rules = [
                ...this.props.validators,
                Rules.isChecked
            ];
        }

        for (let {func, msg} of rules) {
            let test = func.call(this);
            isValid = isValid && test;
            message = msg;
            if (!test) break; // break on the first failed test.
        }

        this.setState({
            isValid: isValid,
            error_message: message
        });

        return isValid;
    }

    forceInvalidate = (message) => {
        this.setState({
            isValid: false,
            error_message: message || null,
            forced_error: true
        });
    }

    handleChange = (e) => {
        if (!this.state.isValid) {
            this.validate();
        }
        this.setState(state => ({
            checked: !state.checked
        }), () => {
            this.props.onChange(this.state.checked);
        });

    }

    render = () => {
        let errors = null;

        if (!this.state.isValid) {
            errors = (<div className="errors-list" style={{opacity: this.state.show_errors ? 1 : 0}}>
                <span>{this.state.error_message}</span>
            </div>);
        }

        return (
            <div className={classnames('checkbox', this.props.className, {
                'collapse': this.props.collapse,
                'checkbox-inline': this.props.inline
            })}>
                <label htmlFor={this.props.id} className={this.props.required ? 'required' : null}>
                    <input
                        className={classnames({
                            'success': this.state.isValid,
                            'error': !this.state.isValid
                        })}
                        ref={ref => (this._input = ref)}
                        checked={this.state.checked || false}
                        // defaultValue={this.props.value}
                        type="checkbox"
                        name={this.props.name || this.props.id}
                        id={this.props.id}
                        required={this.props.required}
                        onChange={this.handleChange}
                        placeholder={this.props.placeholder}
                        disabled={this.props.disabled}
                    />{' '}
                    {this.props.label || this.props.children}
                </label>
                {errors}
            </div>
        );
    }
}
